import { render, staticRenderFns } from "./policies.vue?vue&type=template&id=9b4fa45a&"
import script from "./policies.vue?vue&type=script&lang=js&"
export * from "./policies.vue?vue&type=script&lang=js&"
import style0 from "./policies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports